import React from 'react';
import { isSameDay, differenceInCalendarDays, format, parseISO } from 'date-fns';

import { getTimeFromDateString } from '@root/Helpers/DateTimeHelper';
import { dateFromState, dateToState } from "../../Helpers/DateTimeHelper";
import StandardTooltip from "../StandardTooltip";

const AvailabilityButton = (props) => {

    const getButtonContent = () => {
        if (!props.availability) {
            return 'Unknown';
        }
        let content = `${getTimeFromDateString(props.availability.start)} - ${getTimeFromDateString(props.availability.end)}`

        if (isMultiDaySlot()) {
            content += ' (Next Day)';
        }
        return content;
    }

    const isMultiDaySlot = () => {
        if (!props.availability) {
            return false;
        }
        return !isSameDay(
            dateFromState(props.availability.start),
            dateFromState(props.availability.end)
        );
    }

    const handleClick = (evt) => {
        props.onClick({
            start: props.availability.start,
            end: props.availability.end,
        })
    }

    const getButton = () => {
        return <button
            type="button"
            className={`button round availability-button ${props.active ? 'primary' : 'secondary'} ${isMultiDaySlot()
                ? 'multi-day'
                : ''}`}
            onClick={handleClick}
            disabled={props.disabled}
        >
            {getButtonContent()}
        </button>
    }

    return (props.hideTooltip)
        ? getButton()
        : (
            <StandardTooltip
                title={`${props.availability.remaining} bookings remaining`}
                enterDelay={750}
            >
                {getButton()}
            </StandardTooltip>
        );
}

AvailabilityButton.defaultProps = {
    disabled: false,
    active: false,
    hideTooltip: false,
}

export default AvailabilityButton;
